exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-icon[data-v-34464287]{margin-left:16px;height:32px}.balance-background[data-v-34464287]{display:block;margin-top:-24px;margin-left:auto;margin-bottom:-8px;max-width:190px;width:60%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34464287","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/detail/Balance.vue
// module id = 1454
// module chunks = 1